import { createContext as createZustandContext, useContextSelector } from '@prophecy/utils/react/useZustandContext';

import { WorkspaceFabricContextValue } from './types';

export const { Context: WorkspaceFabricStoreContext, Provider: WorkspaceFabricStoreContextProvider } =
  createZustandContext<WorkspaceFabricContextValue | null>(null);

export function useWorkspaceFabricContext(): WorkspaceFabricContextValue;
export function useWorkspaceFabricContext<Selected>(
  selector: (value: WorkspaceFabricContextValue) => Selected
): Selected;
export function useWorkspaceFabricContext<Selected>(selector?: (value: WorkspaceFabricContextValue) => Selected) {
  return useContextSelector(WorkspaceFabricStoreContext, (state) => {
    if (!state) {
      throw new Error('useWorkspaceFabricContext must be used within WorkspaceFabricProvider');
    }
    return selector ? selector(state) : state;
  });
}
